var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.7 3.5h6.6l1.1 2H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3h2.6l1.1-2Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 16.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
  fill: "#fff"
})));
export { SvgCamera as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNOC43IDMuNWg2LjZsMS4xIDJIMTlhMyAzIDAgMCAxIDMgM3Y4YTMgMyAwIDAgMS0zIDNINWEzIDMgMCAwIDEtMy0zdi04YTMgMyAwIDAgMSAzLTNoMi42bDEuMS0yWiIgLz4KICA8cGF0aCBkPSJNMTIgMTYuNWE0IDQgMCAxIDAgMC04IDQgNCAwIDAgMCAwIDhaIiBmaWxsPSJ3aGl0ZSIgLz4KPC9zdmc+Cg==";